/* global APP_NAME */

function getAppName() {
  return `CORTEX ${APP_NAME.toUpperCase()}`;
}

export { getAppName };
